import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import PageHeader from '../common/header/PageHeader';

type PresentationView = 'personal' | 'shared' | 'feed' | 'archived';

function PresentationsPageHeader({view}: {view: PresentationView}): JSX.Element {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const views = [
        {view: 'personal', icon: 'solar:lock-linear', label: t('navigation.personal'), path: '/presentations'},
        {view: 'shared', icon: 'solar:users-group-rounded-linear', label: t('navigation.shared'), path: '/presentations/shared'},
        {view: 'feed', icon: 'solar:posts-carousel-vertical-linear', label: t('homePage.feed'), path: '/feed'},
        {view: 'archived', icon: 'solar:archive-linear', label: t('navigation.archived'), path: '/presentations/archived'},
    ];

    return (
        <PageHeader
            title={t(view === 'feed' ? 'navigation.feed' : 'navigation.presentations')}
            items={views.map((item) => ({
                icon: item.icon,
                label: item.label,
                active: item.view === view,
                onClick: () => {
                    if (item.view !== view) navigate(item.path);
                },
            }))}
            defaultIndex={views.findIndex((item) => item.view === view)}
        />
    );
}

export default PresentationsPageHeader;
